import React from 'react';

import List from '@zapier/product-get-help/src/components/shared/List';
import { SizeType, TrackingFields } from '@zapier/product-get-help/src/types';

import DocLink from './DocLink';

type Link = {
  href: string;
  title: string;
  appId?: string;
};

type DocLinksProps = {
  /** Docs to link */
  links: Link[];
  /** Size to display. */
  size?: SizeType;
  /** Tracking props */
  trackingFields?: TrackingFields;
};

/** Renders a list of docs. */
const DocLinks = ({ links, size = 'large', trackingFields }: DocLinksProps) => (
  <List
    gap={5}
    itemRenderer={(item: Link) => <DocLink {...item} size={size} trackingFields={trackingFields} />}
    items={links}
  />
);

export default DocLinks;
